var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_3129)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6445 10.4507C39.9796 11.4567 41.6378 13.9915 43.7168 17.4805H35.6445V10.4507ZM10.3104 17.7734C11.1591 17.7734 11.7752 18.1831 11.7752 19.1406C11.7752 19.9482 11.1217 20.6032 10.3146 20.6055H1.46484C0.655746 20.6055 0 21.2616 0 22.0703C0 22.8794 0.655746 23.5352 1.46484 23.5352H14.6484C15.4652 23.5352 16.119 24.1905 16.119 25C16.119 25.8091 15.4633 26.4648 14.6542 26.4648H1.46484C0.655746 26.4648 0 27.1206 0 27.9297C0 28.7388 0.655746 29.3945 1.46484 29.3945H4.6875V33.7891C4.6875 34.5982 5.34325 35.2539 6.15234 35.2539H9.09691C9.62181 37.8395 11.9064 39.7461 14.5996 39.7461C17.2928 39.7461 19.5774 37.8395 20.1023 35.2539H34.9758C35.5007 37.8395 37.7853 39.7461 40.4785 39.7461C43.1717 39.7461 45.4563 37.8395 45.9812 35.2539H48.5352C49.3443 35.2539 50 34.5982 50 33.7891V25C50 20.702 45.4666 20.4166 45.4624 20.4102H34.1797C33.3706 20.4102 32.7148 19.7544 32.7148 18.9453V10.1562H6.15234C5.34325 10.1562 4.6875 10.812 4.6875 11.6211V14.8438H2.92969C2.12059 14.8438 1.46484 15.4995 1.46484 16.3086C1.46484 17.1177 2.12059 17.7734 2.92969 17.7734H10.3104ZM42.3775 32.2319C43.4261 33.2806 43.4261 34.9815 42.3775 36.0302C40.6906 37.7171 37.793 36.517 37.793 34.1309C37.793 31.7451 40.6906 30.545 42.3775 32.2319ZM16.4986 32.2319C17.5472 33.2806 17.5472 34.9815 16.4986 36.0302C14.8117 37.7171 11.9141 36.517 11.9141 34.1309C11.9141 31.7451 14.8117 30.545 16.4986 32.2319Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_3129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastDelivery);
export default __webpack_public_path__ + "static/media/fast-delivery.4bc2b7471259dd8ed4d79c8814182b45.svg";
export { ForwardRef as ReactComponent };